import {Link} from 'react-router-dom';
import React, {useMemo} from 'react';
import AddIcon from 'mdi-react/AddIcon';
import MinusIcon from 'mdi-react/MinusIcon';
import { numberToUSFormat } from '@/shared/helpers';

function makeCell(accessor) {
    return ({row, value}) => {
        const boldRow = row.original.dinamicDepth === 1;
        return <div style={boldRow ? {fontWeight: 'bold'} : {}}>{numberToUSFormat(value, true, "$")}</div>;
    };
}

const makeFooter = (accessor, formatter = (v) => numberToUSFormat(v, true, "$")) => (info) => {
    const { rows } = info;
    const totalValue = useMemo(
        () => rows.reduce((sum, row) => {
            if (row.original?.disableTotalCalculation) return sum;
            if (row.original.dinamicDepth !== 1) return sum;
            return Number(row.values[accessor]) + sum;
        }, 0),
        [rows]
    );
    return <span>{formatter(totalValue)}</span>;
};

export const PROGRAM_COLUMNS = [
    {
        id: 'expander',
        Header: ({getToggleAllRowsExpandedProps, isAllRowsExpanded}) => (
          <span {...getToggleAllRowsExpandedProps()}>
            {isAllRowsExpanded ? '' : ''}
          </span>
        ),
        Cell: ({row}) =>
          row.canExpand ? (
            <span
              {...row.getToggleRowExpandedProps({
                  style: {
                      paddingLeft: `${row.depth * 2}rem`,
                  },
              })}
            >
              {row.isExpanded ? <MinusIcon className="chevron-expand"/> : <AddIcon className="chevron-expand"/>}
            </span>
          ) : null,
        width: 100
    },
    {
        Header: "Program",
        accessor: "name",
        Footer: "Total",
        Cell: ({row, value}) => {
            const space = row.original.dinamicDepth === 1 ? '' : ' • ';
            const boldRow = row.original.dinamicDepth === 1;
            return (
                <div style={boldRow ? {fontWeight: 'bold'} : {}}>
                    {space.repeat(row.original.dinamicDepth)}
                    <Link to={`/program/view/${row.original.id}`}>{value}</Link>
                </div>
            );
        },
        width: 200
    },
    {
        Header: "Program ID",
        accessor: "account_holder_id",
        Footer: "",
        width: 100,
        Cell: ({ row, value }) => {
            return !!row.original?.v2_account_holder_id ? row.original?.v2_account_holder_id : value;
        },
    },
    {
        Header: "Eligible Participants",
        accessor: "participants_count",
        Cell: ({row, value}) => {
            const boldRow = row.original.dinamicDepth === 1;
            return <div style={boldRow ? {fontWeight: 'bold'} : {}}>{value}</div>;
        },
        Footer: (info) => {
            const { rows } = info;
            const totalValue = useMemo(
                () => rows.reduce((sum, row) => {
                    if (row.original?.disableTotalCalculation) return sum;
                    if (row.original.dinamicDepth !== 1) return sum;
                    return Number(row.values.participants_count) + sum;
                }, 0),
                [rows]
            );
            return <span>{totalValue}</span>;
        },
        width: 100,
    },
    { Header: "Jan",             accessor: "month_1",          Cell: makeCell("month_1"),          Footer: makeFooter("month_1") },
    { Header: "Feb",             accessor: "month_2",          Cell: makeCell("month_2"),          Footer: makeFooter("month_2") },
    { Header: "Mar",             accessor: "month_3",          Cell: makeCell("month_3"),          Footer: makeFooter("month_3") },
    { Header: "Apr",             accessor: "month_4",          Cell: makeCell("month_4"),          Footer: makeFooter("month_4") },
    { Header: "May",             accessor: "month_5",          Cell: makeCell("month_5"),          Footer: makeFooter("month_5") },
    { Header: "Jun",             accessor: "month_6",          Cell: makeCell("month_6"),          Footer: makeFooter("month_6") },
    { Header: "Jul",             accessor: "month_7",          Cell: makeCell("month_7"),          Footer: makeFooter("month_7") },
    { Header: "Aug",             accessor: "month_8",          Cell: makeCell("month_8"),          Footer: makeFooter("month_8") },
    { Header: "Sep",             accessor: "month_9",          Cell: makeCell("month_9"),          Footer: makeFooter("month_9") },
    { Header: "Oct",             accessor: "month_10",         Cell: makeCell("month_10"),         Footer: makeFooter("month_10") },
    { Header: "Nov",             accessor: "month_11",         Cell: makeCell("month_11"),         Footer: makeFooter("month_11") },
    { Header: "Dec",             accessor: "month_12",         Cell: makeCell("month_12"),         Footer: makeFooter("month_12") },
    { Header: "YTD",             accessor: "YTD",              Cell: makeCell("YTD"),              Footer: makeFooter("YTD") },
    { Header: "Q1",              accessor: "Q1",               Cell: makeCell("Q1"),               Footer: makeFooter("Q1") },
    { Header: "Q2",              accessor: "Q2",               Cell: makeCell("Q2"),               Footer: makeFooter("Q2") },
    { Header: "Q3",              accessor: "Q3",               Cell: makeCell("Q3"),               Footer: makeFooter("Q3") },
    { Header: "Q4",              accessor: "Q4",               Cell: makeCell("Q4"),               Footer: makeFooter("Q4") },
    { Header: "Per Participant", accessor: "per_participant",  Cell: makeCell("per_participant"),  Footer: makeFooter("per_participant") },
    { Header: "Avg Per Quarter", accessor: "avg_per_quarter",  Cell: makeCell("avg_per_quarter"),  Footer: makeFooter("avg_per_quarter") },
    { Header: "Avg Per Month",   accessor: "avg_per_month",    Cell: makeCell("avg_per_month"),    Footer: makeFooter("avg_per_month") },
    { Header: "Quarter Target",  accessor: "quarterly_target", Cell: makeCell("quarterly_target"), Footer: makeFooter("quarterly_target") },
    { Header: "Monthly Target",  accessor: "monthly_target",   Cell: makeCell("monthly_target"),   Footer: makeFooter("monthly_target") },
    { Header: "Annual Target",   accessor: "annual_target",    Cell: makeCell("annual_target"),    Footer: makeFooter("annual_target") },
];